/**
* Logos Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logos Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'logos-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      const imgs = document.querySelectorAll( '.fade-me' );
      const imgSrcs = [];
      for ( let i = 0; i < imgs.length; i++ ) {
        imgSrcs.push( imgs[i].src );
      }

      window.setInterval( changePicture, 5000 );
      let i = 0;

      function changePicture() {
        i++;
        if ( i > imgSrcs.length - 1 ) i = 0;
        const rando = Math.floor( Math.random() * imgSrcs.length );
        // imgs[i].style.transition = '0.3s';
        // imgs[rando].style.transition = '0.3s';
        // imgs[i].style.opacity = '0';
        // imgs[rando].style.opacity = '0';

        original = imgs[i].getAttribute( 'src' );
        swap = imgs[rando].getAttribute( 'src' );

        imgs[i].setAttribute( 'src', `${swap}` );
        imgs[rando].setAttribute( 'src', `${original}` );

        // imgs[i].style.opacity = '1';
        // imgs[rando].style.opacity = '1';
        imgs[i].style.width = '100%';
        imgs[i].style.height = 'auto';
        imgs[rando].style.width = '100%';
        imgs[rando].style.height = 'auto';
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logos-grid', COMPONENT );
} )( app );
